angular
  .module("pe4h")
  .controller("ViewEngineer", function(
    $scope,
    $rootScope,
    $http,
    $state,
    $stateParams
  ) {

    $scope.loadEngineerInfo = function(id) {
      $http({
        url: configuration.webApi.users.engineer({
          id: id
        }),
        method: "GET"
      })
        .success(function(res, status, headers, config) {
          $scope.profileData.user = res;
        })
        .error(function(error, status, headers, config) {
          $scope.alertErrorFromServer(error);
        });
    };

    function init() {
      $scope.profileData = {};
      $scope.groupedLicenses = [];
      $scope.loadEngineerInfo($stateParams.uid);
    }

    init();
  });
